"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactSelect = void 0;
const react_1 = __importDefault(require("react"));
const react_select_1 = __importDefault(require("react-select"));
const formik_1 = require("formik");
const BaseInput_1 = require("../BaseInput/BaseInput");
exports.ReactSelect = (props) => {
    const { name, options } = props;
    return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    react_1.default.createElement(BaseInput_1.BaseInput, Object.assign({}, props), ({ getInvalidClass, getErrorMessageField, getId, getPlaceholder }) => (react_1.default.createElement(formik_1.Field, { name: name }, (fieldProps) => {
        return (react_1.default.createElement("div", { className: "ReactSelectHelper" },
            react_1.default.createElement(react_select_1.default, Object.assign({}, fieldProps.field, { id: getId(), options: options, classNamePrefix: "ReactSelect", placeholder: getPlaceholder(), className: getInvalidClass(fieldProps), value: options.find((option) => option.value === fieldProps.field.value), onChange: (option) => fieldProps.form.setFieldValue(name, option.value) })),
            getErrorMessageField()));
    }))));
};
//# sourceMappingURL=ReactSelect.js.map